// is-lib/app-class.service.ts
import { Inject, Injectable } from '@angular/core';
import { AppId, IS_APP_ID } from '../constants';

@Injectable({ providedIn: 'root' })
export class AppService {
  constructor(@Inject(IS_APP_ID) public appId: AppId) {}
}
